// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"n_7 container-lg d-flex p-3","doc-page":"n_8","doc-page__title--enterprise":"n_9","doc-page--with-side-menu":"n_bb","doc-page__title":"n_bc"};